export const productNameTransform = (name: string) => {
    return name?.toLowerCase().replace(/ecco/g, "ECCO");
};

export const getImageAltTag = (altTagPattern?: string, imageLabel?: string) => {
    if (!imageLabel) return altTagPattern;
    const imageAlt = imageLabel.charAt(0).toUpperCase() + imageLabel.slice(1);
    return `${altTagPattern} - ${imageAlt}`;
};
